import React from "react";
import { Link } from "react-router-dom";
import CoverPlaceholder from "./CoverPlaceholder";

const formatoValor = (valor) => {
    const num = Math.round(parseFloat(valor) || 0);
    if (!num) return "Gratis";
    return "$" + num.toLocaleString("es-CL");
};

const CourseCard = ({ curso }) => {
    return (
        <Link to={`/curso/${curso.id_rs}`} className="course-card">
            <CoverPlaceholder seed={curso.id_rs} texto={curso.ram_descrip || curso.ram_sigla} />
            <div className="course-card-body">
                {curso.car_sigla && <span className="course-card-tag">{curso.car_sigla}</span>}
                <h3 className="course-card-title">{curso.ram_descrip || curso.ram_sigla}</h3>
                <p className="course-card-sub">{curso.ram_sigla}</p>
                {curso.prof_nombre && curso.prof_nombre.trim() && (
                    <p className="course-card-prof">{curso.prof_nombre}</p>
                )}
                <div className="course-card-meta">
                    {curso.modalidad && <span className="course-card-badge">{curso.modalidad}</span>}
                    {curso.sed_sigla && <span className="course-card-badge">{curso.sed_sigla}</span>}
                </div>
                <p className="course-card-price">{formatoValor(curso.valor)}</p>
            </div>
        </Link>
    );
};

export default CourseCard;
